module.exports = __webpack_public_path__ + "desktop-monitor.320dc5ce377e85441879981b06909d77.svg";